import { useTranslation } from 'react-i18next';
import React from 'react';

const ClosedKiosk = ({ kiosk }) => {
  const { t } = useTranslation();

  const isTime24 = time => time.hours === '23' && time.minutes === '59';

  const formatTime = time => {
    const timeArr = time.split(':');
    const hourMinute = {
      hours: timeArr[0],
      minutes: timeArr[1],
    };

    if (isTime24(hourMinute)) {
      return '24:00';
    }
    return `${hourMinute.hours}:${hourMinute.minutes}`;
  };

  const sortSchedules = (rangeA, rangeB) => {
    const weekDayOrder = {
      MONDAY: 1,
      TUESDAY: 2,
      WEDNESDAY: 3,
      THURSDAY: 4,
      FRIDAY: 5,
      SATURDAY: 6,
      SUNDAY: 7,
    };

    const weekdayOrder = weekDayOrder[rangeA.dayOfWeek] - weekDayOrder[rangeB.dayOfWeek];
    const rangeATime = rangeA.startTime.split(':');
    const rangeBTime = rangeB.startTime.split(':');
    const hourlyOrder = rangeATime[0] - rangeBTime[0];
    const minuteOrder = rangeATime[1] - rangeBTime[1];

    return weekdayOrder || hourlyOrder || minuteOrder;
  };

  return <div style={{ width: '100%' }}>
    <h3>{t('schedule')}</h3>
    {kiosk?.schedule.sort(sortSchedules).map( (range, index) => <div key={index}>{t('weekDays.' +
      range.dayOfWeek)}: {formatTime(range.startTime)} - {formatTime(range.endTime)}</div>)}
  </div>;
};

export default ClosedKiosk;
